import * as Sc from './text.style'

export type TextVariant =
  | 'title0'
  | 'title0Mobile'
  | 'title1'
  | 'title1Mobile'
  | 'title2'
  | 'title2Mobile'
  | 'title3'
  | 'title3Mobile'
  | 'title4'
  | 'title4Mobile'
  | 'title5'
  | 'title5Mobile'
  | 'title6'
  | 'title6Mobile'
  | 'body'
  | 'small'
  | 'superSmall'
  | 'link'
  | 'linkSmall'
  | 'linkSuperSmall'
  | 'button'
  | 'buttonSmall'

export type TextRootNodeComponent =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'
  | 'p'
  | 'span'
  | 'label'

const variantToRootNodeComponent: Record<TextVariant, TextRootNodeComponent> = {
  body: 'p',
  button: 'span',
  buttonSmall: 'span',
  link: 'span',
  linkSmall: 'span',
  linkSuperSmall: 'span',
  small: 'p',
  superSmall: 'p',
  title0: 'h1',
  title0Mobile: 'h1',
  title1: 'h1',
  title1Mobile: 'h1',
  title2: 'h2',
  title2Mobile: 'h2',
  title3: 'h3',
  title3Mobile: 'h3',
  title4: 'h4',
  title4Mobile: 'h4',
  title5: 'h5',
  title5Mobile: 'h5',
  title6: 'h6',
  title6Mobile: 'h6',
}

export type TextProps = {
  /**
   * Whether the text should be bold
   */
  bold?: boolean
  /**
   * Css class to override default styles
   */
  className?: string
  /**
   * The component used for the root node. A string to use as a HTML element.
   * If not provided, it will be inferred from the variant.
   */
  component?: TextRootNodeComponent
  /**
   * A text to indicate data test ID.
   */
  dataTestId?: string
  /**
   * A text to indicate ID.
   */
  id?: string
  /**
   * Variant for the text
   */
  variant: TextVariant
}

type TextPropsWithChildren = TextProps & { children?: React.ReactNode }

const Text = ({
  bold = false,
  children,
  className,
  component,
  dataTestId,
  id,
  variant,
}: TextPropsWithChildren) => {
  if (!component) {
    component = variantToRootNodeComponent[variant]
  }

  return (
    <Sc.Text
      $bold={bold}
      $variant={variant}
      as={component}
      className={className}
      data-testid={dataTestId}
      id={id}
    >
      {children}
    </Sc.Text>
  )
}

export default Text
